<template>
  <v-dialog
    max-width="640"
    :fullscreen="smAndDown"
    v-model="dialogValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    persistent
  >
    <div
      class="tw-relative tw-bg-white tw-py-12 tw-px-14 tw-rounded-2xl tw-h-full tw-overflow-y-auto tw-flex tw-flex-col tw-items-center tw-justify-center"
      :class="{
        'tw-px-4 tw-pt-6 tw-pb-6': smAndDown,
        'tw-rounded-none': smAndDown,
      }"
    >
      <!-- Ilustração -->
      <div class="tw-flex tw-justify-center tw-mb-6">
        <v-img
          src="@/assets/daai-lock-key.svg"
          width="198"
          height="118"
          alt="Complete seu cadastro"
        />
      </div>

      <!-- Título -->
      <h2
        class="tw-text-xl tw-font-semibold tw-text-center tw-mb-3 tw-text-gray-600"
      >
        {{ $t('completeProfileCTAModal.title') }}
      </h2>

      <!-- Descrição -->
      <p class="tw-text-sm tw-text-gray-600 tw-text-center tw-mb-10">
        {{ $t('completeProfileCTAModal.description') }}
      </p>

      <!-- Botão Principal -->
      <div class="tw-flex tw-justify-center tw-mb-4 tw-self-stretch">
        <v-btn
          color="primary"
          variant="flat"
          rounded
          size="large"
          class="tw-h-[52px] tw-px-8 tw-font-semibold tw-rounded-full tw-w-full"
          @click="handleCompleteProfile"
        >
          <v-icon icon="mdi-lock-open-check-outline" class="tw-mr-2" />
          {{ $t('completeProfileCTAModal.primaryButton') }}
        </v-btn>
      </div>

      <!-- Botão Secundário -->
      <div class="tw-flex tw-justify-center">
        <v-btn
          variant="plain"
          color="primary"
          class="tw-font-semibold"
          @click="handleClose"
        >
          {{ $t('completeProfileCTAModal.secondaryButton') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import { useDisplay } from 'vuetify'
import { useUserMetricsStore } from '@/stores/userMetrics'
import { useModalsStore } from '@/stores/modals'

const { smAndDown } = useDisplay()
const userMetricsStore = useUserMetricsStore()
const modalsStore = useModalsStore()
const { hasConsultations } = storeToRefs(userMetricsStore)
const { showCompleteProfileModal, fromOriginProfileModal } =
  storeToRefs(modalsStore)

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const dialogValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const handleCompleteProfile = () => {
  // Fechar este modal
  emit('update:modelValue', false)

  // Abrir o modal de completar perfil
  fromOriginProfileModal.value = hasConsultations.value
    ? 'new-consultation-success'
    : null
  showCompleteProfileModal.value = true
}

const handleClose = () => {
  emit('update:modelValue', false)
}
</script>

<style scoped lang="scss">
:deep() {
  .v-btn--variant-text {
    text-transform: none;
  }
}
</style>
